const locationData = {
    Maharashtra: {
      Mumbai: [
        "Andheri West", "Andheri East", "Bandra West", "Bandra East", "Borivali", "Dadar", "Colaba",
        "Juhu", "Kandivali", "Kurla", "Malad", "Powai", "Worli", "Chembur", "Vikhroli", "Goregaon"
      ],
      Pune: [
        "Shivajinagar", "Hinjewadi", "Kothrud", "Baner", "Viman Nagar", "Wakad", "Koregaon Park"
      ],
      Vasai: [
        "Vasai West", "Vasai East", "Nalasopara", "Virar", "Naigaon"
      ],
      Bandra: [
        "Bandra West", "Bandra East", "Pali Hill", "Carter Road", "Mount Mary"
      ]
    },
    Karnataka: {
      Bengaluru: [
        "Indiranagar", "Whitefield", "HSR Layout", "Jayanagar", "Koramangala", "Malleshwaram",
        "BTM Layout", "Yelahanka", "Electronic City"
      ],
      Mysuru: [
        "VV Mohalla", "Gokulam", "Saraswathipuram", "Jayalakshmipuram", "Lakshmipuram"
      ]
    },
    Goa: {
      Panaji: [
        "Miramar", "Dona Paula", "Altinho", "Campal"
      ],
      Margao: [
        "Fatorda", "Borda", "Navelim", "Aquem"
      ],
      Mapusa: [
        "Assagao", "Siolim", "Anjuna", "Calangute"
      ]
    }
  };
  
  export default locationData;
  